<template>
    <transition
        enter-active-class="transition duration-200"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            style="background-color: rgba(255, 255, 255, 0.93)"
            class="flex flex-col rounded w-full h-full absolute inset-0 z-20"
            v-show="modalOpened"
        >
            <div class="flex items-center justify-between sticky top-0">
                <div class="ml-6" v-if="$slots.title">
                    <slot name="title" />
                </div>
                <icon
                    name="bold/close"
                    class="m-6 z-20 text-xl cursor-pointer text-gray-600 | transition duration-200 | hover:text-gray-800"
                    @click="$emit('close')"
                />
            </div>
            <div class="grow h-0">
                <slot />
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        emits: ['close'],

        props: {
            modalOpened: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
